import { render, staticRenderFns } from "./selectChannelCategory.vue?vue&type=template&id=7645d3cc&"
import script from "./selectChannelCategory.vue?vue&type=script&lang=ts&"
export * from "./selectChannelCategory.vue?vue&type=script&lang=ts&"
import style0 from "./selectChannelCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports